module.exports = __webpack_public_path__ + "f45c37f51de0138650d512ee90c91344.png";